<template>
  <div>
    <v-toolbar>
      <v-container fluid>
        <div class="d-flex align-center">
          <back />
          <h3 class="ml-5 primary--text">
            <portal-target name="UserLeftSide" />
          </h3>
          <v-spacer />
          <portal-target name="UserHeaderRightSide" />
        </div>
      </v-container>
    </v-toolbar>

    <v-container
      class="mt-5"
      fluid
    >
      <router-view />
    </v-container>
  </div>
</template>

<script>
    import Me from "@/mixins/Me";
    import User from "@/mixins/User";
    import Back from "@/components/atoms/Back";

    import {mapMutations} from 'vuex'

    export default {
        name: "UserBase",

        components: {
            Back
        },

        mixins: [
            Me,
            User
        ],

        mounted() {
            this.awaitPromiseCallback({
                key: 'getMe', cb: this.getUserIfNotMe
            })

        },

        methods: {
            ...mapMutations([
                'awaitPromiseCallback'
            ]),

            async getUserIfNotMe() {
                let userId = this.$route.params.userId;
                if (this.me.id != userId) {
                    this.setGlobalLoading(true);
                    await this.getOneUser({id: userId, include: ['laboratory', 'groups', 'roles', 'country']})
                        .catch(e => {
                            console.log("e: ", e);
                        });
                    this.setGlobalLoading(false);
                } else {
                    this.setOneUser(null)
                }

                if (this.$route.name === 'UserBase') {
                    this.$router.replace({name: 'UserAccount', params: {userId: userId}})
                }
            }
        },

    }
</script>

<style scoped>

</style>
